// src/components/SectionsRenderer.jsx
import ReactMarkdown from "react-markdown";
import { Link } from "react-router-dom";
import { useVenueTheme } from "../../hooks/useTheme";
import { FaPhoneAlt, FaIdBadge } from "react-icons/fa";
import {MdEmail, MdPlace} from "react-icons/md";
import { useVenueName } from "../../hooks/useVenueName";
import { useParams } from "react-router-dom";
import { IS_DEMO } from "../../App";
export default function SectionsRenderer({
  sections,
  showTitle = false,
  title = null,
  sekcjaPowitalna
}) {
const { name, loading: nameLoading } = useVenueName();
const { theme, loading: themeLoading } = useVenueTheme(name);
  const { pageId: encodedPageId } = useParams();
  const pageId = encodedPageId ? decodeURIComponent(encodedPageId) : "home";

  if (nameLoading && themeLoading) {
    return null;
  }

return (
  <>
  {sekcjaPowitalna && ["home", "kontakt", "galeria"].includes(pageId) && (
      <section className="relative  text-white overflow-hidden "  style={{
    backgroundColor: sekcjaPowitalna.obraz
      ? "#0f172a" // slate-900
      : theme.primary,
  }}>
        {/* Obraz tła */}
        {sekcjaPowitalna.obraz && (
          <img
            src={sekcjaPowitalna.obraz}
            alt=""
            className="absolute inset-0 w-full h-full object-cover opacity-50"
            loading="lazy"
          />
        )}

        <div className="relative z-10 px-6 py-32 mx-auto max-w-5xl backdrop-blur-sm ">
          {/* Nagłówek */}
          {sekcjaPowitalna.naglowek && (
            <h2 className=" text-white font-serif font-medium mainHeader">
              {sekcjaPowitalna.naglowek}
            </h2>
          )}

          {sekcjaPowitalna.tekst && (
            <div className="max-w-4xl text-lg md:text-xl lg:text-2xl opacity-90 mb-12 leading-relaxed prose prose-invert prose-lg lg:prose-xl">
              <ReactMarkdown>
                {sekcjaPowitalna.tekst}
              </ReactMarkdown>
            </div>
          )}

          {/* Przycisk CTA – teraz z inline style zamiast klas Tailwind */}
          {sekcjaPowitalna.przyciskTekst && sekcjaPowitalna.przyciskLink && (
            <div className="mt-12">
              {sekcjaPowitalna.przyciskLink.startsWith("http") ? (
                <a
                  href={sekcjaPowitalna.przyciskLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block text-white font-bold px-10 py-5 text-xl  shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:scale-105"
                  style={{
                    backgroundColor: theme.primary,
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = theme.secondary)}
                  onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = theme.primary)}
                >
                  {sekcjaPowitalna.przyciskTekst}
                </a>
              ) : (
              <Link
                to={
                  IS_DEMO
                    ? `/${name}${sekcjaPowitalna.przyciskLink.startsWith("/") ? "" : "/"}${sekcjaPowitalna.przyciskLink}`
                    : `${sekcjaPowitalna.przyciskLink.startsWith("/") ? "" : "/"}${sekcjaPowitalna.przyciskLink}`
                }
                className="inline-block text-white font-bold px-10 py-5 text-xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:scale-105"
                style={{
                  backgroundColor: theme.primary,
                }}
                onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = theme.secondary)}
                onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = theme.primary)}
              >
                {sekcjaPowitalna.przyciskTekst}
              </Link>
              )}
            </div>
          )}
        </div>
      </section>
    )}
  <div className="mx-auto px-4 max-w-screen-2xl py-8 md:py-16">
    {showTitle && (
      <h1 className="header text-center mb-12">
        {title || "Podgląd strony"}
      </h1>
    )}
    
    {sections.map((s, i) => {
      
      // ==================== TYP: GALLERY ====================
      if (s.type === "gallery") {
        return (
          <section key={i} className="mb-20 py-8">
            <div className="max-w-7xl mx-auto">
              {s.title && (
                <h2 className="header text-center mb-12">
                  {s.title}
                </h2>
              )}
              {s.images && s.images.length > 0 ? (
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
                  {s.images
                    .sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
                    .map((img, imgIdx) => (
                      <div
                        key={imgIdx}
                        className="group relative overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 "
                      >
                        <img
                          src={img.url}
                          alt={`${s.title || "Galeria"} – zdjęcie ${imgIdx + 1}`}
                          className="w-full h-64 md:h-80 object-cover transition-transform duration-700 group-hover:scale-110"
                          loading="lazy"
                        />
                      </div>
                    ))}
                </div>
              ) : (
                <p className="text-center text-gray-500 py-16 text-lg">
                  Brak zdjęć w galerii
                </p>
              )}
            </div>
          </section>
        );
      }

      // ==================== TYP: CONTACT ====================
      if (s.type === "contact") {
        return (
          <section key={i} className="py-16">
            <div className="max-w-7xl mx-auto">
              {s.title && (
                <h2 className="header text-center mb-12">
                  {s.title}
                </h2>
              )}

              {/* Dane + mapa */}
              <div className="bg-white shadow-2xl overflow-hidden mb-16 ">
                <div className="grid lg:grid-cols-2">
                  {/* Lewa kolumna – gradient */}
                  <div
                    className="py-12 px-10 text-white"
                    style={{
                      background: `linear-gradient(to bottom right, ${theme.primary}, ${theme.secondary})`,
                    }}
                  >
                    <h3 className="text-3xl font-bold mb-10">Dane kontaktowe</h3>
                    <div className="space-y-8 text-lg">
                      {s.address && (
                        <div className="flex items-start gap-4">
                          <MdPlace className="text-2xl mt-1 flex-shrink-0" />
                          <div>
                            <p className="font-semibold">Adres</p>
                            <p className="opacity-90" dangerouslySetInnerHTML={{ __html: s.address }} />
                          </div>
                        </div>
                      )}
                      {s.phone && (
                        <div className="flex items-center gap-4">
                          <FaPhoneAlt className="text-2xl flex-shrink-0" />
                          <div>
                            <p className="font-semibold">Telefon</p>
                            <p className="opacity-90">{s.phone}</p>
                          </div>
                        </div>
                      )}
                      {s.email && (
                        <div className="flex items-center gap-4">
                          <MdEmail className="text-2xl flex-shrink-0" />
                          <div>
                            <p className="font-semibold">Email</p>
                            <p className="opacity-90">{s.email}</p>
                          </div>
                        </div>
                      )}
                      {s.nip && (
                        <div className="flex items-center gap-4">
                          <FaIdBadge className="text-2xl flex-shrink-0" />
                          <div>
                            <p className="font-semibold">NIP</p>
                            <p className="opacity-90">{s.nip}</p>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Mapa */}
                  <div className="min-h-96">
                    {s.mapIframe ? (
                      <div
                        className="w-full h-full"
                        dangerouslySetInnerHTML={{ __html: s.mapIframe }}
                      />
                    ) : (
                      <div className="w-full h-full bg-gray-200 flex items-center justify-center text-gray-500">
                        Brak mapy
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* Formularz */}
              <div className="bg-white shadow-2xl p-10 lg:p-16 ">
                <h3 className="header text-center mb-10">Wyślij zapytanie</h3>
                <form className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
                  {[
                    { label: "Imię i nazwisko", type: "text", placeholder: "Jan Kowalski" },
                    { label: "Telefon", type: "tel", placeholder: "+48 500 400 300" },
                    { label: "Email", type: "email", placeholder: "email@example.com" },
                  ].map((f, idx) => (
                    <div key={idx}>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        {f.label}
                      </label>
                      <input
                        type={f.type}
                        required
                        placeholder={f.placeholder}
                        className="w-full px-5 py-4 border focus:outline-none focus:ring-4 focus:ring-offset-2"
                        style={{ "--tw-ring-color": theme.ring }}
                      />
                    </div>
                  ))}

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Rodzaj imprezy
                    </label>
                    <select
                      required
                      className="w-full px-5 py-4 border focus:outline-none focus:ring-4 focus:ring-offset-2"
                      style={{ "--tw-ring-color": theme.ring }}
                    >
                      <option value="">Wybierz</option>
                      <option>Wesele</option>
                      <option>Urodziny</option>
                      <option>Impreza firmowa</option>
                      <option>Inne</option>
                    </select>
                  </div>

                  <div className="md:col-span-2">
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Wiadomość
                    </label>
                    <textarea
                      rows={6}
                      required
                      className="w-full px-5 py-4 border focus:outline-none focus:ring-4 focus:ring-offset-2"
                      style={{ "--tw-ring-color": theme.ring }}
                    />
                  </div>

                  <div className="md:col-span-2 text-center">
                    <button
                      type="submit"
                      className="px-12 py-5 text-white font-semibold text-lg transition transform hover:scale-105 shadow-lg "
                      style={{
                        backgroundColor: theme.primary,
                      }}
                      onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = theme.secondary)}
                      onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = theme.primary)}
                    >
                      Wyślij wiadomość
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </section>
        );
      }

      // ==================== TYP: TILES ====================
      if (s.type === "tiles") {
        return (
          <section key={i} className="mb-20">
            {s.title && (
              <h2 className="header text-center mb-12">
                {s.title}
              </h2>
            )}
            <div className="flex flex-wrap -mx-5 justify-center">
              {s.items
                .sort((a, b) => (a.order ?? 999) - (b.order ?? 999))
                .map((item, idx) => (
                  <div
                    key={idx}
                    className="w-full md:w-1/2 lg:w-1/3 px-5 mb-10"
                  >
                    <div className="bg-white overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 flex flex-col h-full ">
                      {item.image && (
                        <img
                          src={item.image}
                          alt={item.title || "Kafelek"}
                          className="w-full h-64 object-cover "
                        />
                      )}
                      <div className="p-8 flex-1 flex flex-col">
                        {item.title && (
                          <h3 className="text-2xl font-semibold mb-4 text-gray-800">
                            {item.title}
                          </h3>
                        )}
                        <div className="prose prose-base md:prose-lg max-w-none text-gray-700 mb-6 flex-1">
                          <ReactMarkdown>{item.text || ""}</ReactMarkdown>
                        </div>
                        {item.cta && item.cta.text && item.cta.link && (
                          <div className="mt-auto">
                            {item.cta.link.startsWith("http") ? (
                              <a
                                href={item.cta.link}
                                target={item.cta.target || "_blank"}
                                rel={item.cta.target === "_blank" ? "noopener noreferrer" : undefined}
                                className="inline-block text-white font-bold px-8 py-4 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 "
                                style={{
                                  backgroundColor: theme.primary,
                                }}
                                onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = theme.secondary)}
                                onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = theme.primary)}
                              >
                                {item.cta.text}
                              </a>
                            ) : (
                              <Link
                                to={item.cta.link}
                                className="inline-block text-white font-bold px-8 py-4 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 "
                                style={{
                                  backgroundColor: theme.primary,
                                }}
                                onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = theme.secondary)}
                                onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = theme.primary)}
                              >
                                {item.cta.text}
                              </Link>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </section>
        );
      }

      // ==================== TYP: CTA ====================
      if (s.type === "cta") {
        return (
          <section key={i} className="mb-20">
            <div
              className="shadow-2xl p-12 md:p-20 text-center text-white overflow-hidden "
              style={{
                background: `linear-gradient(to right, ${theme.primary}, ${theme.secondary})`,
              }}
            >
              {s.title && (
                <h2 className="header mb-8">
                  {s.title}
                </h2>
              )}
              {s.text && (
                <div className="prose prose-lg lg:prose-xl max-w-4xl mx-auto text-white/90 mb-12">
                  <ReactMarkdown>{s.text}</ReactMarkdown>
                </div>
              )}
              {s.cta && s.cta.text && s.cta.link && (
                <div>
                  {s.cta.link.startsWith("http") ? (
                    <a
                      href={s.cta.link}
                      target={s.cta.target || "_blank"}
                      rel={s.cta.target === "_blank" ? "noopener noreferrer" : undefined}
                      className="inline-block bg-white text-gray-900 hover:bg-gray-100 font-bold text-2xl md:text-3xl px-12 py-6 shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:scale-105 "
                    >
                      {s.cta.text}
                    </a>
                  ) : (
                <Link
                  to={
                    IS_DEMO
                      ? `/${name}${s.cta.link.startsWith("/") ? "" : "/"}${s.cta.link}`
                      : `${s.cta.link.startsWith("/") ? "" : "/"}${s.cta.link}`
                  }
                  className="inline-block bg-white text-gray-900 hover:bg-gray-100 font-bold text-2xl md:text-3xl px-12 py-6 shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:scale-105"
                >
                  {s.cta.text}
                </Link>
                  )}
                </div>
              )}
            </div>
          </section>
        );
      }

      // ==================== TYP: DOMYŚLNY (tekst + zdjęcie) ====================
      const hasImage = s.image && s.imagePosition !== "none";
      const imageOnRight = s.imagePosition === "right";

      return (
        <section
          key={i}
          className={`mb-20 flex flex-col items-center ${hasImage ? "md:flex-row" : ""} gap-12 md:gap-20 ${imageOnRight ? "md:flex-row-reverse" : ""}`}
        >
          {hasImage && (
            <img
              src={s.image}
              alt={s.title || "Zdjęcie sekcji"}
              className="w-full md:w-1/2 lg:w-2/5 object-cover shadow-xl "
              loading="lazy"
            />
          )}
          <div className="flex-1 max-w-4xl mx-auto">
            {s.title && (
              <h2 className="header mb-8">
                {s.title}
              </h2>
            )}
            <div className="prose prose-lg lg:prose-xl text-gray-700 markdown-preview">
              <ReactMarkdown>{s.text || ""}</ReactMarkdown>
            </div>
          </div>
        </section>
      );
    })}
  </div>
  </>
);
}